// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

const getPageStyle = (props) => {
  const { fullPageView, isOTpScreenEnabled, showNewOtpScreen } = props;

  if (fullPageView && isOTpScreenEnabled && showNewOtpScreen) {
    return 'max-width:600px;margin:0 auto; display: flex;align-items: center; justify-content: center;';
  }
  if (fullPageView) {
    return 'max-width:450px;margin:0 auto;';
  }
  return '';
};

const styles = css`
  ${(props) => getPageStyle(props)}
  .text-style-1 {
    color: ${(props) => props.theme.colors.TEXT.ORANGE};
    text-transform: uppercase;
  }
  .text-style-2 {
    color: ${(props) => props.theme.colors.TEXT.LIGHTBLUE};
    text-transform: uppercase;
  }
  .text-style-3 {
    color: ${(props) => props.theme.colors.TEXT.DARKPINK};
    text-transform: uppercase;
  }

  .my-place-rewards .text-style-1 {
    color: ${(props) => props.theme.colors.TEXT.ORANGE};
    text-transform: uppercase;
  }
  .my-place-rewards .text-style-2 {
    color: ${(props) => props.theme.colors.TEXT.LIGHTBLUE};
    text-transform: uppercase;
  }
  .my-place-rewards .text-style-3 {
    color: ${(props) => props.theme.colors.TEXT.DARKPINK};
    text-transform: uppercase;
  }
  .underline {
    border-bottom: 2px solid ${(props) => props.theme.colorPalette.blue[200]};
    width: 150px;
    margin: ${(props) => props.theme.spacing.ELEM_SPACING.REG} auto
      ${(props) => props.theme.spacing.ELEM_SPACING.XS} auto;
  }

  .reset-pwd {
    text-decoration: underline;
  }
  .align-center {
    display: flex;
    justify-content: center;
  }
  .parent-wrapper {
    padding: ${(props) =>
        props.isNewRegisteredFlow || props.loginFlowUXEnhancementEnabled ? '16px' : '40px'}
      28px 60px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      padding: 28px 28px 60px;
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      padding: ${(props) => (props.loginFlowUXEnhancementEnabled ? '4px' : '40px')} 28px 60px;
    }
  }
  .newRegisteredFlow {
    background: ${(props) => props.theme.colors.WHITE};
  }
  .img-parent {
    img {
      height: 62px;
      @media only screen and (max-width: 767px) {
        height: 42px;
      }
    }
    border-bottom: 1px solid
      ${(props) =>
        props.fullPageView ? props.theme.colors.WHITE : props.theme.colors.PRIMARY.BLUE};
  }
  .my-rewards-img-wrapper {
    width: 192px;
  }
  .labels-wrapper {
    padding-left: ${(props) => (props.fullPageView ? '40px' : '20px')};
    padding-right: ${(props) => (props.fullPageView ? '40px' : '20px')};
  }
  .logo-seperator {
    width: 100px;
    height: 1px;
    transform: translate(0, 28px) rotate(90deg);
    background-color: ${(props) => props.theme.colors.PRIMARY.GRAY};
    display: inline-block;
    margin: 0 -15px;
  }
  .spend-points {
    color: ${(props) => props.theme.colorPalette.gray[700]};
  }

  .my-place-rewards {
    font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
    color: ${(props) => props.theme.colorPalette.gray[700]};
  }

  .signed-up-in-store {
    border-bottom: 1px solid
      ${(props) =>
        props.fullPageView ? props.theme.colors.WHITE : props.theme.colors.PRIMARY.BLUE};
  }

  .info-icon-img-wrapper {
    display: block;
    margin: auto;
    width: 10px;
  }
  .position-relative {
    position: relative;
  }
  .hide-show {
    position: absolute;
    right: ${(props) => (props.isNewRegisteredFlow ? '16px' : '0px')};
    width: 30px;
  }
  .position-relative .rightAlignedContent {
    top: ${(props) => (props.isSafari ? '8px' : '25px')};
  }
  .confirm-pwd-hide-show {
    top: 24px;
  }
  .checkbox-hide-show {
    label {
      height: auto;
      border-bottom: 1px solid;
    }
    input {
      display: none;
    }
  }
  .hide-show.show-hide-icons {
    position: absolute;
    top: ${(props) => (props.isSafari ? '4%' : '24%')};
    right: 16px;
  }
  .elem-pb-XS .rightAlignedContent {
    top: 18px;
    position: absolute;
    right: 8px;
  }
  .create-account-btn {
    padding: 20px 0 15px;
    button {
      cursor: pointer;
    }
  }
  .already-account {
    text-decoration: underline;
  }
  .TextBox__error,
  .Checkbox__error {
    font-size: 12px;
    font-weight: bold;
  }
  .create_earn_points,
  .create-reward-points {
    display: inline-block;
  }
  .line-break {
    display: block;
    text-align: center;
  }
  @media ${(props) => props.theme.mediaQuery.smallMax} {
    .create-account {
      display: block;
    }
    .line-break {
      display: initial;
    }
  }
  .position-relative .success__checkmark {
    ${(props) =>
      props.isSafari &&
      `
        top: 15px;
      `}
  }
  .header-wrapper {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }
  .container {
    padding: 12px;
    width: 220px;
  }
  .right-border {
    border-right: 1px solid #d8d8d8;
  }
`;
export const customSpinnerStyle = css`
  .spinner-overlay {
    position: absolute;
  }
`;
export default styles;
